
<div class="container">
    <div class="premium-access-content">
        <img src="assets/img/logo_new1.png" style="max-height: 120px" class="mb-3"  alt="logo">

        <span class="sub-title" style="font-family: Raleway; font-size: 22pt; color:rgb(2, 82, 108);">Discentya</span>
        <h2 style="font-family: Raleway; font-weight: lighter;">Segui i tuoi corsi in autonomia con la nuova piattaforma LMS</h2>

        <img class="mt-3" src="assets/img/t-cap-school.jpg">

        <p style="font-family: Raleway; font-size: 13pt; color:rgb(2, 82, 108);">Investire nello sviluppo delle competenze individuali determina la crescita dell'operatività e garantisce il successo aziendale.</p>
        <div class="option-item">
            <a *ngIf="!(idUser>0)" (click)="showLogin()" class="default-btn" style="cursor: pointer; font-family: Raleway;"><i class="flaticon-user"></i>
                Accedi / Login<span></span>
            </a>
            <a *ngIf="idUser>0" href="elenco-corsi/i-miei-corsi" class="default-btn" style="cursor: pointer; font-family: Raleway;"><i class="flaticon-agenda"></i>
                I miei corsi<span></span>
            </a>
            <a *ngIf="idUser>0" class="default-btn ms-1" (click)="logout()" style="padding-left: 30px; background-color: var(--bs-danger); cursor: pointer; font-family: Raleway;">
                Esci
            </a>
        </div>
    </div>
</div>
